export default __webpack_public_path__ + "static/media/portfolio-hover-157.d2d83e7b.jpg";